var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    rx: 8,
    fill: "#f1613f",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3340_4024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13C21.25 12.0054 20.8549 11.0516 20.1517 10.3483C19.4484 9.64509 18.4946 9.25 17.5 9.25C16.5054 9.25 15.5516 9.64509 14.8483 10.3483C14.1451 11.0516 13.75 12.0054 13.75 13C13.75 17.375 11.875 18.625 11.875 18.625H23.125C23.125 18.625 21.25 17.375 21.25 13Z",
    stroke: "#f1613f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5813 21.125C18.4714 21.3144 18.3137 21.4717 18.1239 21.581C17.9341 21.6903 17.719 21.7478 17.5 21.7478C17.281 21.7478 17.0659 21.6903 16.8761 21.581C16.6864 21.4717 16.5286 21.3144 16.4188 21.125",
    stroke: "#f1613f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3340_4024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a66a20af5bdb1e2abf785b1f0262057a.svg";
export { ForwardRef as ReactComponent };